import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsAddNoteTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_ADD_NOTE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_REPORT_NOTE;

	get id(): string {
		return TourId.REPORTS__ADD_NOTE;
	}

	override get keyForPersistantDone(): string {
		return ReportsAddNoteTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.UP,
				allowStacked: false,
				attachTo: () => {
					return $('.report_slide_desc .content').eq(0);
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		// user manually closed - mark all slides tours as done
		this.flowTourReportsSlidesService.endAllTours();
		super.onExplicitClose();
	}
}
